"use client";
import Image from "next/image";
import Link from "next/link";
import { EmbeddedForm } from "./embeddedForm";
import { useTranslation } from "@/app/i18n/client";
import AppleIcon from "@/assets/images/logos/Apple_logo.svg";
import facebook_black from "@/assets/images/logos/facebook_black.svg";
import GooglePlayIcon from "@/assets/images/logos/google_play_icon.svg";
import instagram_black from "@/assets/images/logos/instagram_black.svg";
import linkedin_black from "@/assets/images/logos/linkedin_black.svg";
import vee_logo_large from "@/assets/images/logos/vee-logo-png.png";
import CustomButton from "@/common/customElements/button";
import HexagonButton from "@/common/customElements/HexagonButton";
import {
  AbsoluteDiv,
  CustomDiv,
  InlineDiv,
  Separator,
  VerticalCenterDiv,
} from "@/common/divs";
import "./footer.css";
import { LightText, RegularText, TextLink } from "@/common/texts";
import {
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR,
  SECONDARY_BUTTON_COLOR,
} from "@/utils/constants";
import routes from "@/utils/routes.json";

const FooterLayout: React.FC = () => {
  const { t, i18n } = useTranslation();
  return (
    <footer>
      <CustomDiv
        id="footerHeight"
        width="100%"
        background={NEUTRO_TITLES_COLOR}
        paddingX="108px"
        paddingY="40px"
      >
        <InlineDiv className="responsiveFlexDiv">
          <section>
            <Image
              src={vee_logo_large}
              alt="logo"
              width={123}
              height={46}
              className="h-auto"
              quality={100}
              priority={true}
            />
            <InlineDiv style={{ marginTop: "15px" }}>
              <HexagonButton
                width="50px"
                backgroundColor={PRIMARY_BUTTON_COLOR}
                onClick={() => {
                  window.open(
                    "https://www.facebook.com/VeeSightseeing",
                    "_blank",
                    "noreferrer",
                  );
                }}
              >
                {" "}
                <Image
                  alt="facebook"
                  width="24"
                  height="24"
                  src={facebook_black.src}
                  style={{
                    position: "absolute",
                    top: "23%",
                    left: "26%",
                    width: "24px",
                    height: "24px",
                  }}
                />
              </HexagonButton>
              <HexagonButton
                width="50px"
                marginX="15px"
                backgroundColor={PRIMARY_BUTTON_COLOR}
                onClick={() => {
                  window.open(
                    "https://www.instagram.com/vee.travel/",
                    "_blank",
                    "noreferrer",
                  );
                }}
              >
                <Image
                  alt="instagram"
                  width="24"
                  height="24"
                  src={instagram_black.src}
                  style={{
                    position: "absolute",
                    top: "23%",
                    left: "26%",
                    width: "24px",
                    height: "24px",
                  }}
                />
              </HexagonButton>
              <HexagonButton
                width="50px"
                marginX="15px"
                backgroundColor={PRIMARY_BUTTON_COLOR}
                onClick={() => {
                  window.open(
                    "https://www.linkedin.com/company/vee-sightseeing/",
                    "_blank",
                    "noreferrer",
                  );
                }}
              >
                {" "}
                <Image
                  alt="linkedin"
                  width="24"
                  height="24"
                  src={linkedin_black.src}
                  style={{
                    position: "absolute",
                    top: "23%",
                    left: "26%",
                    width: "24px",
                    height: "24px",
                  }}
                />
              </HexagonButton>
            </InlineDiv>
          </section>
          <section className="wrapItemsDiv">
            {routes.map((route, index) => {
              return (
                <div key={index} className="itemWidth">
                  <Link
                    href={
                      i18n.language == "en" ?
                        route["en-route"]
                      : route["es-route"]
                    }
                  >
                    <TextLink>{t(route.i18_tag)}</TextLink>
                  </Link>
                </div>
              );
            })}
          </section>

          <section className="marginOnResponsive">
            <RegularText
              style={{ marginLeft: "2px" }}
              color={SECONDARY_BUTTON_COLOR}
              fontSize="14px"
            >
              {t("footer.suscribe_description")}
            </RegularText>

            <EmbeddedForm />
          </section>
        </InlineDiv>
        <Separator />
        <InlineDiv height="82px" marginY="16px" className="lastFooterContainer">
          <VerticalCenterDiv className="rightsReservedContainer">
            <LightText color={SECONDARY_BUTTON_COLOR} fontSize="14px">
              Vee Sightseeing{" "}
              {
                //process.env.VERSION
              }{" "}
              ® {t("footer.rights")}
            </LightText>

            <Link href="/terms-and-conditions">
              <LightText color={SECONDARY_BUTTON_COLOR} fontSize="14px">
                Terminos y condiciones
              </LightText>
            </Link>
            <Link href="/aviso-legal">
              <LightText color={SECONDARY_BUTTON_COLOR} fontSize="14px">
                Aviso legal
              </LightText>
            </Link>
          </VerticalCenterDiv>
          <AbsoluteDiv right="0" className="downloadButtonsContainer">
            <InlineDiv className="wrapLastDiv">
              <div>
                <RegularText color={SECONDARY_BUTTON_COLOR} fontSize="14px">
                  {t("footer.download")}
                </RegularText>
                <CustomButton
                  toBeResponsive={true}
                  marginY="7px"
                  width="197px"
                  height="50px"
                  backgroundColor={PRIMARY_BUTTON_COLOR}
                  onClick={() => {
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.vee.traveler&hl=es_es&pli=1",
                      "_blank",
                      "noreferrer",
                    );
                  }}
                >
                  <InlineDiv className="centerDiv">
                    <Image
                      src={GooglePlayIcon.src}
                      alt="googlePlay"
                      width={25}
                      height={27}
                      style={{
                        marginRight: "8px",
                        width: "25px",
                        height: "27px",
                        alignSelf: "center",
                      }}
                    />
                    <div>
                      <LightText fontSize="14px" color={NEUTRO_TITLES_COLOR}>
                        {t("footer.available")}
                      </LightText>
                      <RegularText fontSize="14px" color={NEUTRO_TITLES_COLOR}>
                        Google Play
                      </RegularText>
                    </div>
                  </InlineDiv>
                </CustomButton>
              </div>
              <div className="AppleDiv">
                <RegularText color={SECONDARY_BUTTON_COLOR} fontSize="14px">
                  {t("footer.download")}
                </RegularText>
                <CustomButton
                  toBeResponsive={true}
                  marginY="7px"
                  width="197px"
                  height="50px"
                  onClick={() => {
                    window.open(
                      "https://apps.apple.com/es/app/vee-sightseeing/id1625223257",
                      "_blank",
                      "noreferrer",
                    );
                  }}
                  backgroundColor={PRIMARY_BUTTON_COLOR}
                >
                  <InlineDiv className="centerDiv">
                    <Image
                      src={AppleIcon.src}
                      alt="apple"
                      width={25}
                      height={25}
                      style={{
                        marginRight: "8px",
                        width: "25px",
                        height: "25px",
                        alignSelf: "center",
                      }}
                    />
                    <div>
                      <LightText fontSize="14px" color={NEUTRO_TITLES_COLOR}>
                        {t("footer.available")}
                      </LightText>
                      <RegularText fontSize="14px" color={NEUTRO_TITLES_COLOR}>
                        App store
                      </RegularText>
                    </div>
                  </InlineDiv>
                </CustomButton>
              </div>
            </InlineDiv>
          </AbsoluteDiv>
        </InlineDiv>
      </CustomDiv>
    </footer>
  );
};

export default FooterLayout;
